import React from 'react'
import MusicMarketingFirstSection from './MusicMarketingFirstSection'
import MusicMarketingSecondSection from './MusicMarketingSecondSection'
import MusicMarketingThirdSection from './MusicMarketingThirdSection'
import MusicMarketingFourthSection from './MusicMarketingFourthSection'

function MusicMarketing() {
    return (
        <div>
            <MusicMarketingFirstSection />
            <MusicMarketingSecondSection />
            <MusicMarketingThirdSection />
            <MusicMarketingFourthSection />
        </div>
    )
}

export default MusicMarketing
